"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const h = require("./html");
class Loader {
    constructor(key, buttonLabel, fetcher, updater, refreshSeconds) {
        this.key = key;
        this.buttonLabel = buttonLabel;
        this.fetcher = fetcher;
        this.updater = updater;
        this.refreshSeconds = refreshSeconds;
        this.data = null;
        const t = this;
        addEventListener('storage', e => {
            if (e.key == key) {
                t.loadData();
                t.updater();
            }
        });
    }
    dontStore() {
        return this.refreshSeconds !== undefined && this.refreshSeconds == 0;
    }
    setData(data) {
        this.data = {
            time: Date.now(),
            data: data,
        };
        if (!this.dontStore()) {
            localStorage.setItem(this.key, JSON.stringify(this.data));
        }
        this.updater();
    }
    loadData() {
        if (this.dontStore()) {
            return;
        }
        const value = localStorage.getItem(this.key);
        if (!value) {
            return;
        }
        try {
            const parsed = JSON.parse(value);
            if (!parsed['time'] || !parsed['data']) {
                return;
            }
            this.data = parsed;
        }
        catch (e) {
            console.error(`Couldn't parse ${this.key}`, e);
        }
    }
    getData() {
        this.loadData();
        if (this.data) {
            return this.data.data;
        }
        else {
            return null;
        }
    }
    async fetch(button) {
        button.disabled = true;
        try {
            this.setData(await this.fetcher());
        }
        finally {
            button.disabled = false;
        }
    }
    render(e) {
        this.loadData();
        const div = h.div(e, 'refresh-button');
        const button = h.button(e);
        this.button = button;
        button.innerText = this.buttonLabel;
        button.onclick = async () => {
            this.fetch(button);
        };
        if (this.refreshSeconds !== undefined) {
            if (!this.data ||
                Date.now() - this.data.time > 1000 * this.refreshSeconds) {
                this.fetch(button);
            }
        }
        h.span(e).innerText =
            `Last fetch: ${this.data ? new Date(this.data.time) : 'never'}`;
    }
    progress(done, total) {
        if (this.button) {
            const suffix = done == total ? '' : ` ${done}/${total}`;
            this.button.innerText = this.buttonLabel + suffix;
        }
    }
}
exports.Loader = Loader;
